<script setup lang="ts">
import { onMounted } from 'vue'

defineLayout({
  label: 'Hyatt Sunscape Layout',
  colors: {
    fields: {
      picker: true,
      palette: true,
    },
    background: {
      picker: true,
      palette: true,
    },
    foreground: {
      picker: true,
      palette: true,
    },
  },
  colorPalette: {
    '#126479': {
      fields: true,
      background: true,
      foreground: true,
    },
    '#FFA07D': {
      fields: true,
      background: true,
      foreground: true,
    },
    '#3b4852': {
      fields: true,
      background: true,
      foreground: true,
    },
    '#00bdc6': {
      fields: true,
      background: true,
      foreground: true,
    },
  },
})

const isVoixTemplatizer = inject<boolean>('isVoixTemplatizer', false)
const { getCommonLayoutData, playaLayoutMounted, setupHeader } = usePlayaLayout()

const links: Array<object> = [
  { rel: 'icon', href: '/imgs/hyatt/favicons/icon-192.png', type: 'image/png' },
  { rel: 'apple-touch-icon', href: '/imgs/hyatt/favicons/apple-touch-icon.png', type: 'image/png' },
  { rel: 'manifest', href: '/imgs/hyatt/favicons/manifest.json', type: 'application/json' },
]

if (!isVoixTemplatizer)
  setupHeader('f1c748e5-8ed2-46df-aee5-1ffc70f24022', links)

const {
  resorts,
  brands,
  currentResort,
} = await getCommonLayoutData(isVoixTemplatizer, ['footerCompanyMenu', 'footerResourcesMenu'])

onMounted(() => {
  if (!isVoixTemplatizer)
    return
  playaLayoutMounted(currentResort)
})

provide('accentColor', { value: '#024263' })

if (currentResort?.value)
  provide('currentResort', currentResort.value.data)

if (resorts?.value)
  provide('resorts', resorts.value.data)

if (brands?.value)
  provide('brands', brands.value.data)
</script>

<template>
  <div>
    <div class="text-primary-copy-color bg-primary-bg-color hyatt-dreams-theme">
      <div id="app">
        <div id="portal-destination" />
        <div
          id="portal-mobile-menu"
          role="navigation"
        />

        <div id="playa-content font-light" style="padding-top: 100px;">
          <HyattTopNavigation
            v-if="!isVoixTemplatizer"
            :current-resort="currentResort?.data"
            :resorts="resorts?.data"
          />
          <HyattNavigation
            v-if="!isVoixTemplatizer"
            :current-resort="currentResort?.data"
            :resorts="resorts?.data"
            class="!z-40"
            :is-sunscape="true"
          />

          <slot />

          <HyattFooter v-if="!isVoixTemplatizer" />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@use '~/assets/css/hyatt-sunscape.scss' as *;
</style>
